<section id="social">
  <!-- Close button -->
  <div id="close-social"><img src="assets/img/design/close.png" width="36" height="36" alt="Close"><br />Close
  </div>
  <!-- Sidebar -->
  <div id="sidebar"></div>
</section>
